/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ManualSyncAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function ManualSyncAction({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Images/Content/Content/Content/Content/AlignItero/Content/Content/Content/Created/ManualSyncAction",
  isSubmitting
  
}) {
let dtSpaceXxl = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxl'
        })
let iteroScanIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'itero_scan',
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let onClick = fromHelpers.useOnSubmit({
  children,
  viewPath,
  isSubmitting
  
})
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginTop={dtSpaceXxl}
 size="large"
 text="If the scan has been completed and you have not yet received the results here, try syncing manually"
/>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 alignSelf="center"
 size="small"
 type="secondary"
 marginTop={dtSpaceS}
 onClick={onClick}
 data="itero_scan"
 disabled={iteroScanIsSubmittingData}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Try Sync"
/>
)}
</TysiaButton>
{children}
</React.Fragment>)
}